export const ActionLogStateConstant = {
  FilterStateName: 'actionLogFilter',
};

export const ActionLogFilterActions = {
  SetFilter: 'SET_ACTIONLOG_FILTER',
};
